import React from 'react';
import type { OfferAttachment } from '../../../types';
import { offerAttachmentFileSrc } from '../utils/offerFirstPageImages';
import { OfferAttachmentPdfThumb } from './OfferAttachmentPdfThumb';

type Props = {
  leadRouteId: string;
  attachments: OfferAttachment[];
};

/** Extra A4 sheets under the invoice so PDF attachments are visible before export. */
export function OfferAttachmentPreviewPages({ leadRouteId, attachments }: Props) {
  if (attachments.length === 0) return null;
  const total = 1 + attachments.length;
  return (
    <div className="mx-auto mt-4 flex w-full max-w-[210mm] flex-col gap-4">
      {attachments.map((attachment, index) => {
        const isPdf = attachment.mime_type === 'application/pdf';
        return (
          <article
            key={attachment.id}
            className="theme-light relative flex aspect-[210/297] w-full items-center justify-center bg-app-surface p-6 shadow-[0_4px_24px_rgba(0,0,0,0.08)] ring-1 ring-black/[0.06]"
          >
            {isPdf ? (
              <div className="flex h-full w-full flex-col items-center justify-center gap-3">
                <div className="h-[70%] w-full max-w-md">
                  <OfferAttachmentPdfThumb leadRouteId={leadRouteId} attachment={attachment} />
                </div>
                <p className="max-w-full truncate px-4 text-center text-[9.5pt] text-neutral-600">
                  {attachment.filename}
                </p>
              </div>
            ) : (
              <img
                src={offerAttachmentFileSrc(leadRouteId, attachment.object_path)}
                alt={attachment.filename}
                className="max-h-full max-w-full object-contain"
              />
            )}
            <p className="absolute bottom-4 right-6 text-[7.5pt] tracking-wide text-neutral-400">
              Seite {index + 2} von {total}
            </p>
          </article>
        );
      })}
    </div>
  );
}
